import React, { Component } from "react";
import background from "../../imgs/coming-soon.png";
export default class Home extends Component {
  render() {
    return (
      <div>
        <div
          className="coming-soon d-flex flex-column align-items-center justify-content-center"
          style={{ backgroundImage: `url(${background})` }}
        >
          <h1 className="text-xl text-white spaced losnello">COMING</h1>
          <h1 className="text-xl text-white spaced losnello">SOON</h1>
        </div>
      </div>
    );
  }
}
